import React from 'react';
import PropTypes from 'prop-types';

import XLSX from 'xlsx/xlsx';
import Button from 'components/button';
import styles from './styles.css';

import {formatDateTime} from '../../../core/utils'

export default class OrderDetailExportData extends React.Component {
    static propTypes = {
        orderData: PropTypes.array,
    };

    state = {}

    handleExport() {
        this.setState({loading: true});
        
        const orderHeader = [['Detalle de Pedido'], []];
        const itemsHeader = [['Listado de Productos'], []];
        const logsHeader = [['Historial'], []];
        
        const orderDetail = [
            ['Id Pedido', 'Fecha', 'Realizado por', 'Email', 'Notas', 'Organización', 'CUIT', 'Envío a nombre de', 'Domicilio Envío', 'Telefono Contacto', 'Estado Pedido'],
            [
                this.props.orderData.id,
                formatDateTime(this.props.orderData.created),
                `${this.props.orderData.createdBy.firstName}, ${this.props.orderData.createdBy.lastName}`,
                this.props.orderData.createdBy.email,
                this.props.orderData.extraData.notes,
                this.props.orderData.organization.name,
                this.props.orderData.organization.cuit,
                this.props.orderData.shippingAddress && this.props.orderData.shippingAddress.name,
                this.props.orderData.shippingAddress && `${this.props.orderData.shippingAddress.locality.label}, ${this.props.orderData.shippingAddress.street}, CP: ${this.props.orderData.shippingAddress.postalCode}`,
                this.props.orderData.shippingAddress && this.props.orderData.shippingAddress.phone,
                this.props.orderData.status.name,
            ],
        ];

        const orderItemList = [['Id Producto', 'Codigo', 'Producto', 'Cantidad', 'Precio', 'SubTotal', 'Variación Id']];
        if ((this.props.orderData.shipments.length > 0) && (this.props.orderData.shipments[0].items.length > 0)) {
            this.props.orderData.shipments[0].items.map((element) => orderItemList.push([element.id, element.code, element.name, element.quantity, `${element.price} ${element.priceCurrency}`, element.total, element.productVariation.product.id]));
        }

        const logsData = [['Creación Log', 'Desde Estado', 'Hacia Estado']];
        if (this.props.orderData.log.length > 0) {
            this.props.orderData.log.map((element) => logsData.push([formatDateTime(element.created), element.statusFrom.name, element.statusTo.name]));
        }

        let cursorPosition = 1;

        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.aoa_to_sheet(orderHeader);
        XLSX.utils.book_append_sheet(workbook, worksheet, `Detalle_Pedido_${this.props.orderData.id}`);
        cursorPosition += 1;
        XLSX.utils.sheet_add_aoa(worksheet, orderDetail, {origin: `A${cursorPosition}`});
        cursorPosition += 3;
        XLSX.utils.sheet_add_aoa(worksheet, itemsHeader, {origin: `A${cursorPosition}`});
        cursorPosition += 1;
        XLSX.utils.sheet_add_aoa(worksheet, orderItemList, {origin: `A${cursorPosition}`});
        cursorPosition += this.props.orderData.shipments[0] && this.props.orderData.shipments[0].items.length + 2;
        XLSX.utils.sheet_add_aoa(worksheet, logsHeader, {origin: `A${cursorPosition}`});
        cursorPosition += 1;
        XLSX.utils.sheet_add_aoa(worksheet, logsData, {origin: `A${cursorPosition}`});

        XLSX.writeFile(workbook, `Pedido_id_${this.props.orderData.id}.xlsx`);

        this.setState({loading: false});
    }

    render() {
        return (
            <Button className={styles.downloadButton} onClick={() => this.handleExport()} theme='yellow' disabled={this.state.loading}>
                {this.state.loading ? 'Exportando...' : 'Exportar Orden'}
            </Button>
        );
    }
}



// WEBPACK FOOTER //
// ./views/order-detail/order-detail-export/index.js